import { createReducer, on } from '@ngrx/store';

import { IRateDetail, IRateInquiryItem, IRateSearch } from '@ruby/modules/rate-inquiry/models/rate-inquiry.interface';
import * as RateCoreActions from '@ruby/modules/rate-inquiry/store/actions/rate-core.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'core';

export interface State {
  results: Array<IRateDetail>;
  loading: boolean;
  rateInquiryItem?: IRateInquiryItem;
  inquiryList: number;
  error?: IError;
  displayForm: boolean;
  displayResults: boolean;
  displayList: boolean;
  searchList: Array<IRateSearch>;
}

export const initialState: State = {
  loading: false,
  results: [],
  displayForm: true,
  displayResults: false,
  displayList: false,
  searchList: [],
  inquiryList: 0
};

export const reducer = createReducer(
  initialState,
  on(RateCoreActions.searchInquiry, state => ({
    ...state,
    results: [],
    loading: true,
    displayResults: true,
    displayList: false
  })),
  on(RateCoreActions.searchInquirySuccess, (state, action) => ({
    ...state,
    results: [...state.results, ...action.data],
    loading: false
  })),
  on(RateCoreActions.searchInquiryFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(RateCoreActions.exportFile, state => ({
    ...state,
    loading: true,
    error: undefined
  })),
  on(RateCoreActions.exportFileSuccess, state => ({
    ...state,
    loading: false,
    error: undefined
  })),
  on(RateCoreActions.exportFileFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(RateCoreActions.setRateInquiryItem, (state, action) => ({
    ...state,
    rateInquiryItem: action.data
  })),
  on(RateCoreActions.setInquiryList, (state, action) => ({
    ...state,
    inquiryList: action.data
  })),
  on(RateCoreActions.clearItem, (state, action) => ({
    ...state,
    rateInquiryItem: undefined
  })),
  on(RateCoreActions.updateLayout, (state, action) => ({
    ...state,
    displayForm: action.data
  })),
  on(RateCoreActions.clearAllRateData, state => ({
    ...state,
    loading: false,
    results: [],
    searchList: [],
    rateInquiryItem: undefined,
    displayForm: true,
    displayResults: false,
    displayList: false,
    inquiryList: 0
  })),
  on(RateCoreActions.clearRateSearchList, state => ({
    ...state,
    searchList: [],
    inquiryList: 0,
    displayList: false
  })),
  on(RateCoreActions.addRateSearchItem, (state, action) => ({
    ...state,
    searchList: [...state.searchList, action.data],
    displayList: true
  })),
  on(RateCoreActions.setRateSearchList, (state, action) => ({
    ...state,
    searchList: action.data
  })),
  on(RateCoreActions.setDisplayList, (state, action) => ({
    ...state,
    displayList: action.data
  }))
);
